angular.module("labApp").factory("TeamSettingsFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/khutils/teamsetting/', {
        get: {
            method: 'GET'
        }
    });
}]);